export default __webpack_public_path__ + "static/media/Resource-Icons-Sensory-transparent.c0221eeb.png";